import script from "./TableAction.vue?vue&type=script&setup=true&lang=js"
export * from "./TableAction.vue?vue&type=script&setup=true&lang=js"

import "./TableAction.vue?vue&type=style&index=0&id=dac6a6d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac6a6d2"]])

export default __exports__